/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'navigation';
const componentName = 'applications-vertical-nav';
const prefix = `${moduleName}.${componentName}`;

export const vsVipsLabel = `${prefix}.vsVipsLabel`;
export const poolsLabel = `${prefix}.poolsLabel`;
export const poolGroupsLabel = `${prefix}.poolGroupsLabel`;
export const gslbServicesLabel = `${prefix}.gslbServicesLabel`;

export const ENGLISH = {
    [vsVipsLabel]: 'VS VIPs',
    [poolsLabel]: 'Pools',
    [poolGroupsLabel]: 'Pool Groups',
    [gslbServicesLabel]: 'GSLB Services',
};
